import { Tooltip } from 'react-tooltip';
import { getOpeningHours } from '../../../functions/OperatingHours';

const currentDate = new Date();
const currentDay = currentDate.toLocaleString('en-UK', { weekday: 'long' });
const openingHours = getOpeningHours();

export default function OpeningTimesTooltip(props: any): JSX.Element {
    const { stylingRegion } = props;
    const tooltipId: string = `${stylingRegion}-opening-times-tooltip`; // Generate a unique ID

    return (
        <span
                className={`${stylingRegion}-opening-times-title`}
                data-tooltip-id={tooltipId}
                data-tooltip-variant="dark"
            >
                See our opening times
            <Tooltip
                id={tooltipId} // Use the unique ID
                place="bottom"
                openOnClick={true}
                className="tooltip"
            >
                <div className={`${stylingRegion}-opening-times-container`}>
                    {Object.keys(openingHours).map((day) => (
                        <span
                            key={day}
                            className={currentDay === day ? `${stylingRegion}-current-day` : ''}
                        >
                            {day}: {openingHours[day].open || openingHours[day].close ? `${openingHours[day].open} - ${openingHours[day].close}` : 'Closed'}
                        </span>
                    ))}
                </div>
            </Tooltip>
        </span>
    );
}